import { ReactNode } from "react";

interface HelpLayoutProps {
  children: ReactNode;
  title?: string;
}

export default function HelpLayout({
  children,
  title = "Central de suporte",
}: HelpLayoutProps) {
  return (
    <div className="w-full min-h-screen">
      <div className="px-2 sm:px-6 py-2 sm:py-10 w-full max-w-7xl mx-auto">
        <h1 className="mb-6 sm:mb-8 text-2xl font-bold text-n-green sm:text-3xl">
          {title}
        </h1>

        <div className="mt-4 sm:mt-6">{children}</div>
      </div>
    </div>
  );
}
